import { render, staticRenderFns } from "./SingleStudentIndexView.vue?vue&type=template&id=a79fae7a"
import script from "./SingleStudentIndexView.vue?vue&type=script&lang=js"
export * from "./SingleStudentIndexView.vue?vue&type=script&lang=js"
import style0 from "./SingleStudentIndexView.vue?vue&type=style&index=0&id=a79fae7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports